import { RequestActionType } from '@strata/react-chat';
import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';

import { RequestSummarySection } from 'components/requests/dialogs/RequestSummarySection';
import { type PayerRequestActionDialogProps } from 'services/interfaces';
import { usePostRequestActivityMutation } from 'store/api/payerRequestApi';

const Title = 'Close Request';

export const CloseRequestDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => {
    const [postRequestActivity] = usePostRequestActivityMutation();
    return (
        <Dialog
            dialogTitle={`Confirm ${Title}`}
            width={600}
            isOpen
            secondaryButtonLabel="No, Return To Request Details"
            onSecondaryButtonClick={onClose}
            primaryButtonLabel={`Yes, ${Title}`}
            onPrimaryButtonClick={() => {
                void (async () => {
                    await postRequestActivity({
                        payerId,
                        requestId: requestDetails.requestId,
                        actionType: RequestActionType.COMPLETED,
                    }).unwrap();

                    SuccessToast({ message: 'Request closed successfully.' });
                    onClose();
                })();
            }}
            dialogContent={
                <>
                    <div className="margin__bottom--medium">
                        Are you sure you want to close this request?
                    </div>
                    <RequestSummarySection requestDetails={requestDetails} />
                </>
            }
        />
    );
};

CloseRequestDialog.Title = Title;
